import { Component, Inject, ElementRef, Input, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Store } from '@se/se.ui.advanced';
import { pointer, select } from 'd3-selection';

import { CaliperFactoryService } from '../../utils/caliper-factory.service';
import { TraceViewModel } from '../../view-models/trace-viewmodel';
import { CaliperViewModel } from '../../view-models/caliper-viewmodel';
import { EcgState, CaliperMessage } from '../../redux/ecgstate';
import { MessageActions } from '../../redux/actions';
import { EcgStore } from '../../redux/providers';

@Component({
    selector: '[ecg-trace]',
    templateUrl: './trace.component.html',
    styleUrls: ['./trace.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class TraceComponent implements OnDestroy, OnInit {
    // data members

    @Input()
    trace!: TraceViewModel;

    // constructor

    constructor(
        private elementRef: ElementRef,
        @Inject(EcgStore) private store: Store<EcgState>,
        private caliperFactoryService: CaliperFactoryService,
    ) {}

    // public functions

    ngOnInit() {
        let element: any = select(this.elementRef.nativeElement).select('#bandOptions').node();

        select(this.elementRef.nativeElement)
            .select('#bandOptions')
            .on('click', (event) => {
                let coordinates = { x: pointer(event, element)[0], y: pointer(event, element)[1] };
                this.onBandOptionsClicked(coordinates);
            });
    }

    ngOnDestroy() {
        select(this.elementRef.nativeElement).select('#bandOptions').on('click', null);
    }

    onRemoveCaliper(caliper: CaliperViewModel) {
        this.store.dispatch(MessageActions.caliperRemoveMessage(new CaliperMessage(this.trace, caliper)));
    }

    onMeasuresChange(caliper: CaliperViewModel) {
        this.store.dispatch(MessageActions.caliperModifyMessage(new CaliperMessage(this.trace, caliper)));
    }

    // private functions

    private onBandOptionsClicked(coordinates: { x: number; y: number }) {
        const caliper = this.createCaliper(this.trace, coordinates);
        if (!!caliper) this.store.dispatch(MessageActions.caliperAddMessage(new CaliperMessage(this.trace, caliper)));
    }

    private createCaliper(trace: TraceViewModel, coordinates: { x: number; y: number }): CaliperViewModel | null {
        const caliper = this.caliperFactoryService.create(trace, coordinates);
        if (!caliper) return null;
        caliper.opacity = 1;
        caliper.setPositionX(coordinates.x, 15);
        caliper.window.opacity = 0;

        return caliper;
    }
}
